import apiClient from './apiClient'

/**
 * Fetch Credit Info
 * @returns CreditInfo data
 */
export const fetchCredits = async () => await apiClient.get('/api/UserCredits')